/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resourceUpdated, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import updateElement, { updateNarrativeElement } from "../../functions/updateElement";
import generateNarrativeForResearchStudyResource from "../generateNarrativeFunctions/generateNarrativeForResearchStudyResource"
import NarrativeEntry from "../../datatypeComponents/NarrativeEntry";
import MarkdownEntry from "../../datatypeComponents/MarkdownEntry";
import StringEntry from "../../datatypeComponents/StringEntry";
import CodeableConceptEntry from "../../datatypeComponents/CodeableConceptEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import SEVCO, { studyDesignCodeableConceptSet } from "../../dictionaries/SEVCO";

const researchStudyDotPhaseValueSet = [
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C48660", display: "Not Applicable" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C54721", display: "Early Phase 1" },
    { system: "https://fevir.net/sevco", code: "SEVCO:01031", display: "exploratory investigational new drug study" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15600", display: "Phase 1" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15693", display: "Phase 1/Phase 2" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15601", display: "Phase 2" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15694", display: "Phase 2/Phase 3" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15602", display: "Phase 3" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C217025", display: "Phase 3/Phase 4" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15603", display: "Phase 4" },
    { system: "https://fevir.net/sevco", code: "SEVCO:01038", display: "expanded access study" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C198366", display: "Phase 1/Phase 2/Phase 3" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C198367", display: "Phase 1/Phase 3" },
    { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C217024", display: "Phase 2/Phase 3/Phase 4" }
];

const researchStudyPhaseCodeableConceptSet = [
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C54721", display: "Early Phase 1" },
            { system: "https://fevir.net/sevco", code: "SEVCO:01031", display: "exploratory investigational new drug study" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15600", display: "Phase 1" },
            { system: "https://fevir.net/sevco", code: "SEVCO:01030", display: "phase 1 trial" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15693", display: "Phase 1/Phase 2" },
            { system: "https://fevir.net/sevco", code: "SEVCO:01032", display: "phase 1/phase 2 trial" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15601", display: "Phase 2" },
            { system: "https://fevir.net/sevco", code: "SEVCO:01033", display: "phase 2 trial" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15694", display: "Phase 2/Phase 3" },
            { system: "https://fevir.net/sevco", code: "SEVCO:01034", display: "phase 2/phase 3 trial" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15602", display: "Phase 3" },
            { system: "https://fevir.net/sevco", code: "SEVCO:01035", display: "phase 3 trial" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C217025", display: "Phase 3/Phase 4" },
            { system: "https://fevir.net/sevco", code: "SEVCO:01099", display: "phase 3/phase 4 trial" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C15603", display: "Phase 4" },
            { system: "https://fevir.net/sevco", code: "SEVCO:01036", display: "post-marketing study" }
        ]
    },
    {
        "coding": [
            { system: "https://fevir.net/sevco", code: "SEVCO:01038", display: "expanded access study" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C198366", display: "Phase 1/Phase 2/Phase 3" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C198367", display: "Phase 1/Phase 3" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C217024", display: "Phase 2/Phase 3/Phase 4" }
        ]
    },
    {
        "coding": [
            { system: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl", code: "C48660", display: "Not Applicable" }
        ]
    }
];

const ResearchStudyResourceEdit = ({ foi }) => {
    const dispatch = useDispatch();
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;

    const [editResourceState, setEditResourceState] = useState({
        text: resourceJson.text,
        title: resourceJson.title,
        name: resourceJson.name,
        descriptionSummary: resourceJson.descriptionSummary,
        description: resourceJson.description,
        phase: resourceJson.phase,
        studyDesign: resourceJson.studyDesign,
        relatesTo: resourceJson.relatesTo,
        note: resourceJson.note
    });
    const [containedResourceDictionary, setContainedResourceDictionary] = useState({});

    useEffect(() => {
        if (resourceJson) {
            if (Array.isArray(resourceJson.contained) && resourceJson.contained.length > 0) {
                let containedResourceDictionary = {};
                for (const item of resourceJson.contained) {
                    const key = "#" + item.id;
                    containedResourceDictionary[key] = item;
                }
                setContainedResourceDictionary(containedResourceDictionary);
            }
        }
    }, [resourceJson]);

    useEffect(() => {
        if (resourceJson) {
            updateNarrativeElement(editResourceState, "text", parentResourceDetail,
                dispatch);
        }
    }, [editResourceState.text]);

    useEffect(() => {
        if (editResourceState?.title !== undefined &&
            parentResourceDetail.revisedResourceJson.title !== editResourceState.title) {
            console.log("resourceUpdate for ResearchStudy.title");
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            newResourceDetail.revisedResourceJson.title = editResourceState.title;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            dispatch(resourceUpdated(newResourceDetail));
        }
    }, [editResourceState.title]);

    useEffect(() => {
        if (editResourceState?.name !== undefined
            && parentResourceDetail.revisedResourceJson.name !== editResourceState.name) {
            console.log("resourceUpdate for ResearchStudy.name");
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            newResourceDetail.revisedResourceJson.name = editResourceState.name;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            dispatch(resourceUpdated(newResourceDetail));
        }
    }, [editResourceState.name]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "descriptionSummary", "markdown", parentResourceDetail,
                dispatch);
        }
    }, [editResourceState.descriptionSummary]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "description", "markdown", parentResourceDetail,
                dispatch);
        }
    }, [editResourceState.description]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "phase", "CodeableConcept", parentResourceDetail,
                dispatch);
        }
    }, [editResourceState.phase]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "studyDesign", "ArrayOfCodeableConcept", parentResourceDetail,
                dispatch);
        }
    }, [editResourceState.studyDesign]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "relatesTo", "ArrayOfRelatesTo", parentResourceDetail,
                dispatch);
        }
    }, [editResourceState.relatesTo]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "note", "ArrayOfAnnotation", parentResourceDetail,
                dispatch);
        }
    }, [editResourceState.note]);

    return <div>
        {editResourceState && <>
            <StringEntry elementName='title'
                fieldLabel={'Study Title'}
                startingValue={editResourceState.title || ""}
                required={(editResourceState.description || editResourceState.descriptionSummary || editResourceState.phase || editResourceState.studyDesign || editResourceState.relatesTo || editResourceState.note)}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='name' fieldLabel='Study Name (for machine use)'
                startingValue={editResourceState.name || ""} setResourceState={setEditResourceState} />
            <p>Narrative Summary</p>
            <div style={{ marginLeft: "24px" }}>
                <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                    generatedNarrative={generateNarrativeForResearchStudyResource(resourceJson)} startCollapsed
                    startingValue={editResourceState.text} setResourceState={setEditResourceState} />
            </div>
            <MarkdownEntry elementName='descriptionSummary' fieldLabel={'Brief Study Description'}
                startingValue={editResourceState.descriptionSummary || ""} setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='description' fieldLabel={'Long Study Description'}
                startingValue={editResourceState.description || ""} setResourceState={setEditResourceState} />
            <CodeableConceptEntry elementName='phase' fieldLabel='Phase'
                valueSet={researchStudyDotPhaseValueSet} codeableConceptLevelValueSet={researchStudyPhaseCodeableConceptSet}
                startingValue={editResourceState.phase} setResourceState={setEditResourceState} />
            <ArrayEntry datatype='CodeableConcept'
                elementName='studyDesign' fieldLabel='Study Design'
                valueSet={SEVCO.studyDesign} codeableConceptLevelValueSet={studyDesignCodeableConceptSet}
                startingValue={editResourceState.studyDesign} setResourceState={setEditResourceState} />
            <ArrayEntry datatype='RelatesTo'
                containedResourceDictionary={containedResourceDictionary}
                elementName='relatesTo' fieldLabel='Related Item'
                startingValue={editResourceState.relatedArtifact} setResourceState={setEditResourceState} />
            <ArrayEntry datatype='Annotation'
                elementName='note' fieldLabel='Note'
                startingValue={editResourceState.note} setResourceState={setEditResourceState} />
            <br />
        </>}
    </div>
}

export default ResearchStudyResourceEdit;
export { researchStudyDotPhaseValueSet, researchStudyPhaseCodeableConceptSet };